exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td {\n    text-align: center;   \n }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/create-new-entry/monthly-safety-data-entry/safety-report.component.css
// module id = ../../../../../src/app/create-new-entry/monthly-safety-data-entry/safety-report.component.css
// module chunks = main